import { Space } from 'antd';
import React from 'react';
import Validation from './Validation';
import { DynamicObjectType } from 'types/commons';
import FromToWarehouse from './FromToWarehouse';
import ERPInformation from './ERPInformation';
// import Confirmation from './Confirmation';

const RightContent = ({ data }: { data: DynamicObjectType }) => {
  return (
    <Space size={20} direction="vertical" className="w-full">
      {data?.status === 'AWAITING_CONFIRMATION' && <Validation />}
      {/* {data?.status === 'REJECTED' && <Confirmation data={data} />} */}
      <FromToWarehouse data={data} />
      <ERPInformation data={data} />
    </Space>
  );
};

export default RightContent;
